import {
  Callback,
  createEventEmitter,
  VoidCallback,
} from './framework/event-emitter';

type Events = {
  error: Callback<{ error: Error; errorPayload?: any }>;
  warn: Callback<{ message: Error | string }>;
  info: Callback<{ message: string }>;
  'start-recording': VoidCallback;
  'start-delayed-recording': VoidCallback;
  'stop-recording': VoidCallback;
  'save-recording': VoidCallback;
  'select-source': VoidCallback;
  'user-denied-access': VoidCallback;
  'source-selected': Callback<{ source: MediaStream }>;
  'recording-finished': Callback<{ recording: Blob; type: 'webm' | 'mp4' }>;
  'recording-cancelled': VoidCallback;
  toast: Callback<{
    type: 'error' | 'warn' | 'info';
    message: string;
    duration: number;
  }>;
};

export const events = createEventEmitter<Events>();
